import { render, staticRenderFns } from "./scoreboard_with_stream.vue?vue&type=template&id=def8db56&scoped=true&"
import script from "./scoreboard_with_stream.vue?vue&type=script&lang=js&"
export * from "./scoreboard_with_stream.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_with_stream.vue?vue&type=style&index=0&id=def8db56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def8db56",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventScoreboardFull: require('/var/web/bet777.es/components/event/scoreboard_full.vue').default,EventCountdown: require('/var/web/bet777.es/components/event/countdown.vue').default,ElementsImgVideo: require('/var/web/bet777.es/components/elements/img_video.vue').default,EventScoreboardSetsMini: require('/var/web/bet777.es/components/event/scoreboard_sets_mini.vue').default})
